import firebase from 'firebase/app'
require('firebase/auth')

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
}

class Firebase {
  constructor() {
    // firebase.initializeApp(config)

    this.auth = firebase.auth()
  }

  loginWithGoogle = () =>
    this.auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())

  // loginWithFacebook = () =>
  //   this.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider())

  loginWithFacebook = () =>
    this.auth.signInWithRedirect(new firebase.auth.FacebookAuthProvider())

  loginWithOtp = customToken => this.auth.signInWithCustomToken(customToken)

  loginAsGuest = () => this.auth.signInAnonymously()

  getNewToken = () => this.auth.currentUser.getIdToken()

  isAuthenticated = () => !!localStorage.getItem('accessToken')

  getOTP = (phoneNumber, appVerifier) =>
    this.auth
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(confirmationResult => {
        window.confirmationResult = confirmationResult
      })

  logout = () => this.auth.signOut()
}

export default Firebase
